import humanizeString from "string-humanize";

export function humanize(str) {
  let result = humanizeString(str);

  // special cases can be added here
  if (str === "no_cvm") {
    result = "No CVM";
  }

  return result;
}
